import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Newlandiningbanner from "./Newlandiningbanner";
import Franchiesabout from "./Franchiesabout";
import Ladingsideadverticements from "./Ladingsideadverticements";
import Landingfoodpage from "../../Landingmanagment/Landingfoodpage";
import Landingcaterpage from "../../Landingmanagment/Landingcaterpage";
import Landinggrocerypage from "../../Landingmanagment/Landinggrocerypage";
import "./Newlanding.css";

const Newmainlandingpage = () => {
  const [containerHeight, setContainerHeight] = useState(getContainerHeight());

  // ✅ Function to calculate height based on screen width
  function getContainerHeight() {
    const width = window.innerWidth;
    if (width < 768) return "450px";       // Mobile
    if (width < 850) return "450px";       // Below 850px
    if (width < 1400) return "410px";      // 850px–1399px
    if (width < 1600) return "500px";      // 1400px–1599px
    return "500px";                        // Above 1600px
  }

  // ✅ Update height dynamically on window resize
  useEffect(() => {
    const handleResize = () => setContainerHeight(getContainerHeight());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="container-fluid">
      <style>{`
        @media (max-width: 999px) {
          .right-panel {
            display: none !important;
          }
        }
      `}</style>

      <div className="row">
        {/* Left Empty Space */}
        <div className="col-lg-2 col-md-12 col-sm-12 col-12"></div>

        {/* Center Content */}
        <div className="col-lg-12 col-md-12 col-sm-12 col-12 client-banner">
          <div
            style={{
              width: "100%",
              overflowY: "auto",
              height: containerHeight,
              scrollbarWidth: "none",
              scrollBehavior: "smooth",
            }}
          >
            <Newlandiningbanner />
            <Franchiesabout />
            <Landingfoodpage />
            <Landingcaterpage />
            <Landinggrocerypage />
          </div>
        </div>

        {/* Right Advertisement Panel */}
        <div className="col-lg-3 col-md-7 col-sm-12 col-12 right-panel">
          <Ladingsideadverticements />
        </div>
      </div>
    </div>
  );
};

export default Newmainlandingpage;
